<template>
	<section v-loading="loadingDM" style="width: 100%">
		<div class="d-flex mt-3 mb-3" v-if="hasGetTableDataModel">
			<div class="mr-auto" v-if="title">
				<h3 class="mb-0">{{title}}</h3>
			</div>
			<div class="mr-auto">
				<el-checkbox
					:indeterminate="isIndeterminate"
					v-model="isCheckAll"
					@change="handleCheckAllChange"
					v-if="isSelectable"
					class="mr-3"
				>全选</el-checkbox>
				<el-button
					size="mini"
					class="mr-3"
					v-for="op in batchOps"
					:key="op.key"
					:disabled="!isCheckAll && !isIndeterminate"
					@click="handleClickBatchOp(op.key)"
				>{{op.name}}</el-button>
			</div>
			<el-popover placement="bottom" width="300" trigger="click">
				<el-checkbox-group v-model="fieldsShow">
					<el-checkbox
						:key="index"
						v-for="(key,index) in fields"
						:label="key.name"
					>{{key.show_name || dm[key.name].show_name}}</el-checkbox>
				</el-checkbox-group>
				<el-button icon="el-icon-view" circle size="mini" slot="reference"></el-button>
			</el-popover>
		</div>
		<el-table
			:data="tableData"
			style="width: 100%"
			border
			v-loading="loadings.main"
			@sort-change="handleSortChange"
			size="small"
			:show-summary="showSummary"
			:summary-method="getSummaries"
			v-if="hasGetTableDataModel && hasGetData"
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="expand" v-if="hasExpandShow || realExpandFields.length>0">
				<template slot-scope="scope">
					<slot name="expandShow" v-bind:row="scope.row" class="mb-3">
						<el-form label-position="left" label-width="120px" inline class="expand">
							<el-form-item
								:label="key.show_name || dm[key.name].show_name"
								:key="index"
								v-for="(key,index) in realExpandFields"
							>
								<field-show
									:field-info="dm[key.name]"
									:value="scope.row[key.name]"
									:field-key="key"
									v-if="!key.render"
								></field-show>
								<span v-else v-html="key.render(scope.row)"></span>
							</el-form-item>
						</el-form>
					</slot>
				</template>
			</el-table-column>
			<el-table-column width="55" label="选择" v-if="isSelectable">
				<template slot-scope="scope">
					<el-checkbox v-model="checks[scope.$index]" @change="handleCheck(scope.$index)"></el-checkbox>
				</template>
			</el-table-column>

			<el-table-column
				:prop="key.name"
				:label="key.show_name || dm[key.name].show_name"
				:sortable="key.sortable"
				:key="index"
				v-for="(key,index) in realFields"
				:min-width="key.minWidth"
				:width="key.width"
				:fixed="key.fixed"
			>
				<template slot-scope="scope">
					<field-show
						:field-info="dm[key.name]"
						:value="scope.row[key.name]"
						:field-key="key"
						:params="key.params"
						:tooltip-img="key.needThumb?scope.row[key.needThumb]:''"
						v-if="!key.render"
					></field-show>
					<span v-else v-html="key.render(scope.row)"></span>
				</template>
			</el-table-column>
			<el-table-column
				label="操作"
				v-if="listOps.length>0 || hasDelete || hasOpSlot"
				class-name="list-op"
			>
				<template slot-scope="scope">
					<slot name="listOp" v-bind:row="scope.row">
						<el-button
							size="mini"
							type="text"
							@click="handleClick(scope.$index,index)"
							v-for="(op,index) in listOps"
							:key="index"
						>{{op.show_name}}</el-button>
						<el-button size="mini" type="text" @click="handleDelete(scope.row._id)" v-if="hasDelete">删除</el-button>
					</slot>
				</template>
			</el-table-column>
		</el-table>
		<div class="row" v-if="hasPage">
			<div class="col-lg-12 mt-3">
				<el-pagination
					layout="total,prev, pager, next, jumper"
					:total="paginations.main.total"
					:page-size="50"
					:current-page="paginations.main.pageNow"
					background
					@current-change="handlePageChange"
				></el-pagination>
			</div>
		</div>
	</section>
</template>

<script>
import CurdTable from "@/mixins/CurdTable.js";

export default {
	mixins: [CurdTable],
	mounted() {},
	methods: {},
	props: {
		fields: {
			type: Array,
			default: function() {
				return [];
			},
		},
		title: {
			type: String,
			default: "",
		},
	},
	watch:{
		warehouseFilter(val) {
			this.refreshData();
		},
	}
};
</script>
<style>
</style>
